import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/sanctum/login');
  };

  return (
    <div className="dashboard-container">
      <nav className="sidebar">
        <div className="sidebar-header">
          <h2>echo</h2>
          <p className="user-email">{user?.email}</p>
        </div>
        
        <ul className="nav-menu">
          <li>
            <NavLink to="/sanctum" end>
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/sanctum/admins">
              Admins
            </NavLink>
          </li>
          <li>
            <NavLink to="/sanctum/waitlist">
              Waitlist
            </NavLink>
          </li>
          <li>
            <NavLink to="/sanctum/users">
              Users
            </NavLink>
          </li>
        </ul>
        
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </nav>
      
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Dashboard;